export const AUTH_SERVICE_URL = process.env.REACT_APP_AUTH_SERVICE;
export const JSON_CONTENT_TYPE = {
    headers: {
        "Content-Type": "application/json",
    },
};
